import React from 'react'
import { buildAttributeValue } from '../../../selectors/attributes'
import { EXCLUDED_ATTRIBUTES } from './attributesConstants'
import { AttributeRow } from 'client/fragments/productDetailsFragmentInfo/components/Description/CollapsibleAttributes/AttributeRow'

export const AttributesList = ({ attributes, pimAttributesTranslations, lang }) => {
  if (!attributes) return null

  const filteredAttributes = filterExcluded(attributes)
  return filteredAttributes.map(([key, attr], i) => {
    const value = buildAttributeValue(attr, lang)

    const displayName = attr.displayName
    const description = pimAttributesTranslations[`pim.attributes${attr.name}.description`]

    return (
      <li key={`li-${key}`}>
        <dl className='m0'>
          <AttributeRow
            key={`dt-${attr.name}-${i}`}
            index={i}
            displayName={displayName}
            description={description}
            value={value}
          />
        </dl>
      </li>
    )
  })
}

export function filterExcluded(attributes) {
  return Object.entries(attributes).filter(([key, value]) => !EXCLUDED_ATTRIBUTES[key] && !!value)
}
